import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { ThemeContext, themes } from './constants/themes';
import { MixpanelConsumer } from 'react-mixpanel';
import Loader from './components/atoms/Loader';
import Landing from './views/landing';
import Dashboard from './views/dashboard';
import Login from './views/login';
import Settings from './views/settings';
import PostSubscribe from './views/postSubscribe';
import Listen from './views/listen';
import { useAuth0 } from "@auth0/auth0-react";

const App = () => {
  const activeThemeName = localStorage.getItem('theme');
  
  const [state, setState] = useState({
    theme: themes[activeThemeName] || themes.light
  });

  const { isAuthenticated, isLoading } = useAuth0();

  const toggleTheme = () => {
    if (activeThemeName === 'dark') {
      localStorage.setItem('theme', 'light');
      setState({
        ...state,
        theme: themes.light
      });
    } else {
      localStorage.setItem('theme', 'dark');
      setState({
        ...state,
        theme: themes.dark
      });
    }
  }

  if (isLoading) {
    return (
      <div style={{backgroundColor: state.theme.body, minHeight: '100vh'}}>
        <Loader style={{margin: 'auto'}}/>
      </div>
    )
  }

  const noPendingLandingUrl = localStorage.getItem('url') === undefined || localStorage.getItem('url') === null;

  return (
    <div style={{backgroundColor: state.theme.body, minHeight: '100vh'}}>
      <ThemeContext.Provider value={{theme: state.theme, toggleTheme}}>
        <MixpanelConsumer>
          {mixpanel => (
            <Router>
              <Switch>
                <Route exact path='/' render={(props) => {
                  if (isAuthenticated && noPendingLandingUrl) {
                    return <Dashboard {...props} mixpanel={mixpanel} />
                  } else {
                    return <Landing {...props} mixpanel={mixpanel} />
                  }
                }} />
                <Route exact path='/landing' render={(props) => <Landing {...props} mixpanel={mixpanel} />} />
                <Route exact path='/dashboard' render={(props) => <Dashboard {...props} mixpanel={mixpanel} />} />
                <Route exact path='/login' render={(props) => <Login {...props} mixpanel={mixpanel} />} />
                <Route exact path='/settings' render={(props) => <Settings {...props} mixpanel={mixpanel} />} />
                <Route exact path='/post-subscribe' render={(props) => <PostSubscribe {...props} mixpanel={mixpanel} />} />
                <Route exact path='/listen' render={(props) => <Listen {...props} mixpanel={mixpanel} />} />
              </Switch>
            </Router>
          )}
        </MixpanelConsumer>
      </ThemeContext.Provider>
    </div>
  );
}

export default App;
